import { useCallback } from 'react';
import { useDashboard, CrossFilter } from '../context/DashboardContext';

/**
 * Cross-filter: clicking a segment in one chart propagates a filter to all
 * other charts on the dashboard via shared context.
 *
 * isSource  — this chart originated the current filter
 * activeFilter — a filter set by another chart that this chart should apply
 */
export function useCrossFilter(chartId: string) {
  const { crossFilter, setCrossFilter } = useDashboard();

  const applyFilter = useCallback(
    (field: string, value: unknown, label: string) => {
      // Toggle off if already active from this chart
      if (crossFilter?.sourceChartId === chartId && crossFilter.value === value) {
        setCrossFilter(null);
      } else {
        setCrossFilter({ field, value, label, sourceChartId: chartId } satisfies CrossFilter);
      }
    },
    [chartId, crossFilter, setCrossFilter]
  );

  const clearFilter = useCallback(() => setCrossFilter(null), [setCrossFilter]);

  const isSource      = crossFilter?.sourceChartId === chartId;
  const activeFilter  = crossFilter && !isSource ? crossFilter : null;

  return { activeFilter, applyFilter, clearFilter, isSource, crossFilter };
}
